import React from "react";
import styles from "./AddManualCreditFormView.module.scss";
import { DataFormAddManualCredit, ErrorStatus } from "./AddManualCreditForm";
import MessageCard from "../../../../../common/components/molecule/MessageCard/MessageCard";
import Button from "../../../../../common/components/atom/Button/Button";
import TextInput from "../../../../../common/components/atom/TextInput/TextInput";
import SelectInput from "../../../../../common/components/atom/SelectInput/SelectInput";
import { WalletCurrency } from "../../../types/wallet.types";

export interface AddManualCreditFormViewProps {
  dataForm?: DataFormAddManualCredit;
  setDataForm?: (key: keyof DataFormAddManualCredit, value: any) => void;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  handleSubmit?: () => void;
  messageError?: string | null;
  errorStatus?: ErrorStatus;
  disableSubmit?: boolean;
}

const currencyOptions = [
  { value: "FCFA", label: "FCFA" },
];

export default function AddManualCreditFormView({
  dataForm,
  setDataForm,
  submitLabel = "Ajouter le crédit",
  description = "Saisissez le montant et la devise pour ajouter du crédit manuellement",
  maxWidth = "700px",
  isLoading,
  handleSubmit,
  title,
  messageError,
  errorStatus,
  disableSubmit = false,
}: AddManualCreditFormViewProps) {
  return (
    <>
      <div style={{ maxWidth: maxWidth }}>
        <div className={[styles["container"]].join(" ")}>
          {title && (
            <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
          )}
          <p className={[styles["container__description"]].join(" ")}>
            {description}
          </p>
          <div className={[styles["container__error-message"]].join(" ")}>
            <MessageCard variant="danger" message={messageError || errorStatus?.message} width100 />
          </div>
          <form
            className={[styles["form"]].join(" ")}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit && handleSubmit();
            }}
          >
            <div className={[styles["form__item"]].join(" ")}>
              <TextInput
                type="number"
                value={dataForm?.amount?.toString() || ""}
                onChange={(e) => {
                  const value = parseFloat(e.target.value) || 0;
                  if (setDataForm) {
                    setDataForm("amount", value);
                  }
                }}
                label="Montant"
                placeholder="Saisissez le montant"
                error={errorStatus?.isErrorAmount}
              />
            </div>

            <div className={[styles["form__item"]].join(" ")}>
              <SelectInput
                value={dataForm?.currency || "FCFA"}
                handleChange={(value) => {
                  if (setDataForm) {
                    setDataForm("currency", value as WalletCurrency);
                  }
                }}
                label="Devise"
                options={currencyOptions}
                error={errorStatus?.isErrorCurrency}
              />
            </div>

            <div className={[styles["form__button-container"]].join(" ")}>
              <div
                className={[styles["form__button-container__item"]].join(" ")}
              >
                <Button
                  isLoading={isLoading}
                  onClick={handleSubmit}
                  type={"submit"}
                  disabled={disableSubmit || isLoading}
                >
                  {submitLabel}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
